export const canAccess = (role, allowedRoles = []) => {
  if (!role) return false;
  return allowedRoles.includes(role);
};
